import React from 'react';
import { renderByTypeofProp } from '@shared/utils/strings';
import noop from 'lodash/noop';
import { useIntegrationsOnboardingModal } from '@domain/integrations/integrations-onboarding-modal/integrations-onboarding-modal.hooks';
import * as S from './grid-item.styles';

interface Props{
    icon: React.FC<null>;
    isDisabled: boolean;
    subtitle: string;
    title: string;
    id: string;
}

const GridItem = ({
    icon: Icon,
    isDisabled = true,
    subtitle = null,
    title,
    id,
}: Props) => {
    const {
        redirectOrOpenModal,
    } = useIntegrationsOnboardingModal();

    return (
        <S.Item
            onClick={isDisabled
                ? noop
                : () => {
                    redirectOrOpenModal(id);
                }}
            isDisabled={isDisabled}
        >
            <S.ImageWrapper isDisabled={isDisabled}>
                <Icon />
            </S.ImageWrapper>
            <S.Title>{title}</S.Title>
            <S.Subtitle>{renderByTypeofProp(subtitle)}</S.Subtitle>
        </S.Item>
    );
};

export default GridItem;
